<epic-card
	[collapseState]="false"
	class="margin__bottom--large">
	<div
		i18n
		start>
		Filters
	</div>
	<div
		class="row"
		end>
		<epic-icon-button
			(click)="filtersFormGroup.reset(); confirmFilters(); $event.stopPropagation(); clearFilters()"
			[text]="textRemoveFilters"
			hoverColor="var(--color__danger)"
			iconHoverColor="var(--color__white)"
			iconHoverQuerySelector="path"
			iconName="broom" />
	</div>
	<form class="form">
		<epic-form-field
			[text]="textSearch"
			class="form__element-3">
			<epic-input
				[placeholder]="textEnterSearch"
				(keydown.enter)="handleFilterSubmit()"
				[control]="filtersFormGroup.controls.search" />
		</epic-form-field>

		<epic-form-field
			[text]="textCoverageInRevenues"
			class="form__element-3">
			<epic-select [control]="filtersFormGroup.controls.hasInvoices">
				<epic-option
					[value]="undefined"
					i18n>
					Show all
				</epic-option>
				<epic-option
					value="INVOICES_THAT_ARE_COVERED_BY_REVENUES"
					[selected]="filtersFormGroup.controls.hasInvoices.value === 'INVOICES_THAT_ARE_COVERED_BY_REVENUES'"
					i18n>
					Invoices that are covered by revenues
				</epic-option>
				<epic-option
					value="INVOICES_THAT_ARE_NOT_COVERED_BY_REVENUES"
					[selected]="filtersFormGroup.controls.hasInvoices.value === 'INVOICES_THAT_ARE_NOT_COVERED_BY_REVENUES'"
					i18n>
					Invoices that are not covered by revenues
				</epic-option>
			</epic-select>
		</epic-form-field>

		<epic-form-field
			[text]="textPredictions"
			class="form__element-3">
			<epic-select [control]="filtersFormGroup.controls.predictedCost">
				<epic-option
					[value]="undefined"
					i18n>
					Show all
				</epic-option>
				<epic-option
					value="ONLY_COSTS"
					[selected]="filtersFormGroup.controls.predictedCost.value === 'ONLY_COSTS'"
					i18n>
					Only costs
				</epic-option>
				<epic-option
					value="ONLY_PREDICTED_COSTS"
					[selected]="filtersFormGroup.controls.predictedCost.value === 'ONLY_PREDICTED_COSTS'"
					i18n>
					Only predicted costs
				</epic-option>
				<epic-option
					value="ONLY_PREDICTED_PROFORMA_COSTS"
					[selected]="filtersFormGroup.controls.predictedCost.value === 'ONLY_PREDICTED_COSTS'"
					i18n>
					Only predicted proforma costs
				</epic-option>
				<epic-option
					value="INVOICES_MEETING_THE_PREDICTED_COST"
					[selected]="filtersFormGroup.controls.predictedCost.value === 'INVOICES_MEETING_THE_PREDICTED_COST'"
					i18n>
					Invoices meeting the predicted cost
				</epic-option>
				<epic-option
					value="INVOICES_DIFFERING_FROM_THE_PREDICTED_COST"
					[selected]="filtersFormGroup.controls.predictedCost.value === 'INVOICES_DIFFERING_FROM_THE_PREDICTED_COST'"
					i18n>
					Invoices differing from the predicted cost
				</epic-option>
			</epic-select>
		</epic-form-field>
		<epic-form-field
			[text]="textCostInvoiceOrders"
			class="form__element-3">
			<epic-select [control]="filtersFormGroup.controls.orderCost">
				<epic-option
					[value]="undefined"
					i18n>
					Show all
				</epic-option>
				<epic-option
					value="COSTS_WITH_ORDERS"
					[selected]="filtersFormGroup.controls.orderCost.value === 'COSTS_WITH_ORDERS'"
					i18n>
					Cost invoices with orders
				</epic-option>
				<epic-option
					value="COSTS_WITHOUT_ORDERS"
					[selected]="filtersFormGroup.controls.orderCost.value === 'COSTS_WITHOUT_ORDERS'"
					i18n>
					Cost invoices without orders
				</epic-option>
			</epic-select>
		</epic-form-field>
		<div class="form__element-3">
			<epic-form-field-group
				[text]="textDateOfIssue"
				datePicker>
				<epic-input
					[focused]="!!filtersFormGroup.controls.issueDateFrom.value"
					[control]="filtersFormGroup.controls.issueDateFrom"
					[placeholder]="textFrom" />
				<epic-input
					[focused]="!!filtersFormGroup.controls.issueDateTo.value"
					[control]="filtersFormGroup.controls.issueDateTo"
					[placeholder]="textTo" />
			</epic-form-field-group>
		</div>
		<div class="orders-filters__recipient form__element-3">
			@if (aclCanReadContractors()) {
				<epic-form-field [text]="textContractorGroup">
					<epic-autocomplete
						[multiSelect]="true"
						[placeholder]="textSearchRecipient"
						(searchChange)="fetchContractors($event)"
						[control]="filtersFormGroup.controls.contractor"
						[focused]="!!filtersFormGroup.controls.contractor.value"
						[customSelectedValues]="true"
						class="form__element-7">
						<div
							class="epic-select__custom-values"
							selected-values>
						<span
							*ngFor="let contractor of filtersFormGroup.controls.contractor.value"
							class="epic-select__value-round"
						>{{ contractor.name }}</span
						>
						</div>
						@for (contractor of contractors.items; track contractor.id) {
							<epic-option
								[value]="contractor"
								[selected]="checkIfContractorGroupSelected(contractor)"
								class="epic_select__option">
								{{ contractor.name }}
							</epic-option>
						}
					</epic-autocomplete>
				</epic-form-field>
			}
		</div>

		<div class="orders-filters__recipient form__element-3">
			@if (aclCanReadEntities()) {
				<epic-form-field [text]="textEntity">
					<epic-autocomplete
						[multiSelect]="true"
						[placeholder]="textSearchRecipient"
						(searchChange)="fetchEntities($event)"
						[control]="filtersFormGroup.controls.entity"
						[focused]="!!filtersFormGroup.controls.entity.value"
						[customSelectedValues]="true"
						class="form__element-7">
						<div
							class="epic-select__custom-values"
							selected-values>
						<span
							*ngFor="let entity of filtersFormGroup.controls.entity.value"
							class="epic-select__value-round"
						>{{ entity.name }}</span
						>
						</div>
						@for (entity of entities.items; track entity.id) {
							<epic-option
								[value]="entity"
								[selected]="checkIfContractorSelected(entity)"
								class="epic_select__option">
								{{ entity.name }}
							</epic-option>
						}
					</epic-autocomplete>
				</epic-form-field>
			}
		</div>
		<div class="form__element-3">
			@if (aclCanReadPaymentStatus()) {
				<epic-form-field [text]="textPaymentStatus">
					<epic-select
						[focused]="!!filtersFormGroup.controls.paymentStatusID.value"
						[control]="filtersFormGroup.controls.paymentStatusID"
						[customSelectedValues]="true">
						<div
							*ngIf="getSelectedPaymentStatus"
							class="epic-select__custom-values"
							selected-values>
							<span class="epic-select__value-round">{{ getItemTranslation(getSelectedPaymentStatus) }}</span>
						</div>
						<epic-option
							[selected]="false"
							[text]="textShowAll"
							[value]="null" />
						@for (ps of paymentStatuses; track ps.id) {
							<epic-option
								[text]="getItemTranslation(ps)"
								[value]="ps.id" />
						}
					</epic-select>
				</epic-form-field>
			}
		</div>
		<div class="form__element-3">
			<epic-form-field [text]="textCashPayment">
				<epic-select
						[focused]="filtersFormGroup.controls.isPaidCash.value !== null && filtersFormGroup.controls.isPaidCash.value !== undefined"
						[control]="filtersFormGroup.controls.isPaidCash">
					<epic-option
						[selected]="filtersFormGroup.controls.isPaidCash.value === null"
						[text]="textShowAll"
						[value]="null" />
					<epic-option
						[selected]="filtersFormGroup.controls.isPaidCash.value === true"
						[text]="textYes"
						[value]="true" />
					<epic-option
						[selected]="filtersFormGroup.controls.isPaidCash.value === false"
						[text]="textNo"
						[value]="false" />
				</epic-select>
			</epic-form-field>
		</div>
		<div class="form__element-3">
			<epic-form-field [text]="textSentToAccounting">
				<epic-select
						[focused]="filtersFormGroup.controls.sentToAccounting.value !== null && filtersFormGroup.controls.sentToAccounting.value !== undefined"
						[control]="filtersFormGroup.controls.sentToAccounting">
					<epic-option
						[selected]="filtersFormGroup.controls.sentToAccounting.value === null"
						[text]="textShowAll"
						[value]="null" />
					<epic-option
						[selected]="filtersFormGroup.controls.sentToAccounting.value === true"
						[text]="textYes"
						[value]="true" />
					<epic-option
						[selected]="filtersFormGroup.controls.sentToAccounting.value === false"
						[text]="textNo"
						[value]="false" />
				</epic-select>
			</epic-form-field>
		</div>
		<div class="form__element-12 row-reverse">
			<epic-button
				(onClick)="handleFilterSubmit()"
				size="large">
				<epic-icon name="document-2-black" />
				<span i18n>Show documents</span>
			</epic-button>
		</div>
	</form>
</epic-card>

<epic-card [isCollapseAllowed]="false">
	<!-- Card Title	-->
	<div
		class="row gap--large align__center"
		start>
		<span>{{ textListOfCostInvoices }}</span>
		<div>
			@if (aclCanCostInvoicesCreate()) {
				<epic-button
					(onClick)="createCostInvoice()"
					[classes]="['epic-button--square']"
					[epic-tooltip-classes]="['epic-tooltip--square']"
					[epic-tooltip]="textIssueAnInvoice">
					<epic-icon name="plus-mini" />
				</epic-button>
			}
		</div>
	</div>
	<!-- Paginator	-->
	<div class="row justify__end align__center">
		<epic-pagination [pagination]="pagination" />
		@if (aclCanCostInvoicesUpdate()) {
			<epic-icon-button
				(click)="addIncome()"
				hoverColor="var(--color__black)"
				iconHoverColor="var(--color__white)"
				iconHoverQuerySelector="path"
				iconName="add-revenue"
				[text]="textAddIncome" />
			<epic-icon-button
				(click)="bulkMarkAsSentToAccounting()"
				hoverColor="var(--color__black)"
				iconHoverColor="var(--color__white)"
				iconHoverQuerySelector="path"
				iconName="user-check"
				[text]="textBulkSendToAccounting" />
		}
		@if (aclCanCostInvoicesDelete()) {
			<epic-icon-button
				hoverColor="var(--color__danger)"
				iconHoverColor="var(--color__white)"
				iconHoverQuerySelector="path"
				[text]="textDeleteCostInvoices"
				(click)="deleteAll()"
				iconName="delete" />
		}
	</div>
	<!-- Table	-->
	<epic-table
		#tableComponent
		(checkboxesChange)="handleCheckboxesChanges($event)"
		(queryChange)="handleQueryChanges($event)"
		(tableViewInit)="setTableViewSortValue()"
		[generateCheckboxes]="(aclCanCostInvoicesDelete() || aclCanCostInvoicesUpdate())"
		class="font__small">
		<tr
			[is-header-checkbox]="(aclCanCostInvoicesDelete() || aclCanCostInvoicesUpdate())"
			table-headers
			table-row-data>
			<epic-table-header class="table-column__xs font-align__center">
				<span i18n="@@ordinalNumber">No.</span>
			</epic-table-header>
			<epic-table-header
				dataKey="document_number"
				sortable>
				<span i18n>Document number</span>
			</epic-table-header>
			<epic-table-header>
				<span i18n>Container number</span>
			</epic-table-header>
			<!--			<epic-table-header class="table-column__sm">-->
			<!--				<span i18n>Type</span>-->
			<!--			</epic-table-header>-->
			<epic-table-header class="table-column__sm">
				<span i18n>Date</span>
			</epic-table-header>
			<epic-table-header class="table-column__lg">
				<span i18n>Contractor</span>
			</epic-table-header>
			<epic-table-header class="table-column__sm">
				<span i18n>Past Due date</span>
			</epic-table-header>
			<epic-table-header class="table-column__sm">
				<span i18n>Payment date</span>
			</epic-table-header>
			<epic-table-header class="table-column__sm">
				<span i18n>Status</span>
			</epic-table-header>
			<epic-table-header class="table-column__sm">
				<div class="column full-width">
					<span i18n>Net</span>
					<div
						class="invoices__sum-indicator clickable"
						#summaryContainer
						[epic-tooltip]="textChangeSummaryCurrency"
						epic-tooltip-position="right">
						<span
							class="font-weight__regular"
							i18n>
							sum:
						</span>
						<span class="font-weight__bold">
							{{ getNetValueSum() | currency: summaryCurrency : 'symbol' : '0.2-2' : languageCode }}
						</span>
					</div>
				</div>
			</epic-table-header>
			<epic-table-header class="table-column__sm">
				<div class="column">
					<span i18n>Gross</span>
					<div class="invoices__sum-indicator font__small">
						<span
							class="font-weight__regular"
							i18n>
							sum:
						</span>
						<span class="font-weight__bold">
							{{ getGrossValueSum() | currency: summaryCurrency : 'symbol' : '0.2-2' : languageCode }}
						</span>
					</div>
				</div>
			</epic-table-header>
			<epic-table-header></epic-table-header>
		</tr>
		@for (item of items; track item.id) {
			<tr
				[table-row-data]="item"
				[class]="{'focus--border': getLocalStorageScroll?.scrollTargetId === item.id}">
				<td class="table-column__xs font-align__center">{{ $index + 1 }}</td>
				<td
					class="clickable"
					(click)="handleCostInvoiceDetails(item.id)">
					<div class="cost-invoice-list-name">
						@if (item.document_number) {
							{{ item.document_number }}
						} @else {
							<span i18n>Prediction invoice</span>
						}
						<div class="row align__center gap--small">
							<epic-icon
								class="icon-warn"
								[epic-tooltip]="predictedTooltipOf(item)"
								[epic-tooltip-classes]="['epic-tooltip--white-space']"
								*ngIf="showPredictedWarnOf(item)"
								name="warning" />
							<epic-icon
								[epic-tooltip]="textGroupInvoice"
								*ngIf="item.is_group_invoice"
								name="invoice-group" />
							<epic-icon
								[epic-tooltip]="textPreview"
								*ngIf="item.is_predicted"
								name="document-preview" />
							<epic-icon
								[epic-tooltip]="textInvoicesMeetingThePredictedCost"
								*ngIf="isPredictedOf(item)"
								name="document-preview" />
							<span
								*ngIf="item.is_proforma"
								class="invoices__status-tag invoices__status-tag--proforma font__small"
								i18n="@@invoiceTypeProforma"
								[epic-tooltip]="textProformaCostInvoice"
								epic-tooltip-position="right">
							P
						</span>

						</div>
					</div>
				</td>
				<td class="table-column__sm">
					@if (!item.is_group_invoice) {
						@if (item.orders_minimal && item.orders_minimal.length > 0) {
							<span
								class="clickable"
								(click)="goToOrder(item.orders_minimal[0].order_id ?? '')"
							>{{ item.orders_minimal[0].order_container_number }}</span
							>
						} @else {
							{{ item.container_number }}
						}
					} @else {
						@if (item.orders_minimal && item.orders_minimal.length > 0) {
							<div class="cost-invoices-container-flex-main">
								<div class="cost-invoices-container-flex">
									@for (order of getLimitedOrders(item.orders_minimal, item.id); track $index) {
										<span
											class="clickable"
											(click)="goToOrder(order.order_id ?? '')"
										>{{ order.order_container_number }}</span
										>
									}
								</div>
								@if (item.orders_minimal.length > 3) {
									@if (!expandedRows[item.id]) {
										<epic-icon-button
											(click)="showAll(item.id)"
											[hoverColor]="'var(--color__dark)'"
											[iconHoverColor]="'var(--color__white)'"
											[tooltipTextColor]="'var(--color__white)'"
											[iconHoverQuerySelector]="'path'"
											[text]="textPreviewShowAll"
											[iconName]="'eye'" />
									} @else {
										<epic-icon-button
											(click)="showLess(item.id)"
											[hoverColor]="'var(--color__dark)'"
											[iconHoverColor]="'var(--color__white)'"
											[tooltipTextColor]="'var(--color__white)'"
											[iconHoverQuerySelector]="'path'"
											[text]="textPreviewShowLess"
											[iconName]="'eye-hide'" />
									}
								}
							</div>

						} @else {
							{{ item.container_number }}
						}
					}
				</td>
				<!--				<td class="table-column__sm"></td>-->
				<td class="table-column__sm">{{ item.issue_date | date : 'dd.MM.yyyy' }}</td>
				<td class="table-column__lg">{{ item.customer_name }}</td>
				<td class="table-column__sm">{{ item.payment_due_date | date : 'dd.MM.yyyy' }}</td>
				<td class="table-column__sm">
					@if (item.payment_date) {
						{{ item.payment_date | date : 'dd.MM.yyyy' }}
					} @else {
						<div #showDatePickerButton>
							<epic-icon-button
								(click)="resetDateControls()"
								[hoverColor]="'var(--color__dark)'"
								[iconHoverColor]="'var(--color__white)'"
								[tooltipTextColor]="'var(--color__white)'"
								[iconHoverQuerySelector]="'path'"
								[text]="textEnterPaymentDate"
								[iconName]="'calendar'" />
						</div>
						<epic-popover [parentReference]="showDatePickerButton">
							<div
								popover-header
								class="text-no-wrap font__small padding__right"
								i18n>
								Change payment date
							</div>
							<div
								class="epic-popover__list margin--medium"
								popover-content>
								<div>
									<epic-form-field
										[text]="textEnterPaymentDate"
										class="form__element-2"
										datePicker>
										<epic-input
											[control]="dateControl"
											[placeholder]="textSelect" />
									</epic-form-field>
								</div>
								<div class="margin__top--medium row align__center gap--small">
									<epic-checkbox [control]="isPaidCashControl" />
									<span
										class="clickable"
										(click)="isPaidCashControl.setValue(!isPaidCashControl.value)"
									>{{ textPaidWithCash }}</span>
								</div>
								<div class="row-reverse margin__top--medium">
									<epic-button
										(onClick)="changePaymentDate(item)"
										size="large">
										<epic-icon name="document-2-black" />
										<span i18n>Confirm</span>
									</epic-button>
								</div>
							</div>
						</epic-popover>
					}
				</td>
				<td class="table-column__sm ">
					<div class="container-flex justify__space-between row align__center">
						<epic-tag
						[classes]="['tag--small', 'tag--readonly']"
						(click)="openChangeStatusModal(item)"
						[borderColor]="'var(--color__white)'"
						[background]="item?.payment_status?.is_paid? 'var(--color__success)': item?.payment_status?.is_partially_paid? 'var(--color__warning)': 'var(--color__danger)'"
						[hoverColor]="item?.payment_status?.is_paid? 'var(--color__success)': item?.payment_status?.is_partially_paid? 'var(--color__warning)': 'var(--color__danger)'"
						[color]="'var(--color__white)'"
						[text]="getItemTranslation(item?.payment_status)" />
						@if (item.is_paid_cash) {
								<epic-icon
									name="cennik"
									[epic-tooltip]="textCash" />
							}
					</div>
				</td>
				<td class="table-column__sm font-align__right">
					{{ netValueOf(item) | currency: item.currency : 'symbol' : '0.2-2' : languageCode }}
				</td>
				<td class="table-column__sm font-align__right">
					{{ grossValueOf(item) | currency: item.currency : 'symbol' : '0.2-2' : languageCode }}
				</td>
				<td class="cost-invoices__buttons-wrap table-column__xs">
					<div class="cost-invoices__buttons align__center">
						@if (aclCanCostInvoicesUpdate()) {
							@if (item.sent_to_accounting) {
								<epic-icon-button
									class="color__success"
									(click)="toggleSentToAccounting(item)"
									[hoverColor]="'var(--color__dark)'"
									[iconHoverColor]="'var(--color__white)'"
									[tooltipTextColor]="'var(--color__white)'"
									[iconHoverQuerySelector]="'path'"
									[text]="textUnmarkSentToAccounting"
									[iconName]="'user-check'" />
							} @else {
								<epic-icon-button
									class="color__danger"
									(click)="toggleSentToAccounting(item)"
									[hoverColor]="'var(--color__dark)'"
									[iconHoverColor]="'var(--color__white)'"
									[tooltipTextColor]="'var(--color__white)'"
									[iconHoverQuerySelector]="'path'"
									[text]="textMarkAsSentToAccounting"
									[iconName]="'user-dollar'" />
							}
						} @else {
							@if (item.sent_to_accounting) {
								<epic-icon
									class="cost-invoice--icon"
									name="user-check"
									[style.color]="'var(--color__success)'"
									[epic-tooltip]="textSentToAccounting" />
							}
						}
						<epic-icon-button
							(click)="handleCostInvoiceDetails(item.id)"
							[hoverColor]="'var(--color__dark)'"
							[iconHoverColor]="'var(--color__white)'"
							[tooltipTextColor]="'var(--color__white)'"
							[iconHoverQuerySelector]="'path'"
							[text]="textPreviewCostInvoice"
							[iconName]="'eye'" />
						@if (aclCanCostInvoicesUpdate()) {
							<epic-icon-button
								(click)="handleCostInvoiceUpdate(item.id)"
								[hoverColor]="'var(--color__dark)'"
								[iconHoverColor]="'var(--color__white)'"
								[tooltipTextColor]="'var(--color__white)'"
								[iconHoverQuerySelector]="'path'"
								[text]="textEditCostInvoice"
								[iconName]="'edit'" />
							<epic-icon-button
								iconHoverQuerySelector="path"
								(click)="openSelectInvoice(item)"
								[text]="item.is_group_invoice? textAssignationGroupInvoice: item.orders_minimal && item.orders_minimal.length > 0?textUnassignCost: textAssignCost"
								[hoverColor]="'var(--color__dark)'"
								[iconHoverColor]="'var(--color__white)'"
								[tooltipTextColor]="'var(--color__white)'"
								[iconName]="item.orders_minimal && item.orders_minimal.length > 0?'link-off':'clip'" />
						}
						@if (aclCanCostInvoicesDelete()) {
							<epic-icon-button
								(click)="deleteOne(item.id)"
								[hoverColor]="'var(--color__danger)'"
								[iconHoverColor]="'var(--color__white)'"
								[iconHoverQuerySelector]="'path'"
								[text]="textDeleteCostInvoice"
								[iconName]="'delete'" />
						}
					</div>
				</td>
			</tr>
		}
	</epic-table>
	<div class="row-reverse">
		<epic-pagination [pagination]="pagination" />
	</div>
</epic-card>
<epic-popover
	[parentReference]="summaryContainer"
	class="font__small">
	<div
		popover-header
		i18n>
		Currency
	</div>
	<div
		class="epic-popover__list"
		popover-content>
		@for (currency of availableCurrencies; track $index) {
			<div
				(click)="onSummaryCurrencyClick(currency)"
				class="epic-popover__item"
				i18n>
				{{ currency }}
			</div>
		}
	</div>
</epic-popover>
